import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const ChevronDownSmall = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M11.0002 15.3337C10.8549 15.3285 10.7109 15.2638 10.5999 15.1393L5.84054 9.80148C5.60893 9.54245 5.60893 9.1216 5.84054 8.86182C6.07149 8.60205 6.44671 8.60205 6.67835 8.86182L11.0002 13.709L15.322 8.86182C15.5536 8.60205 15.9288 8.60205 16.1598 8.86182C16.3914 9.1216 16.3914 9.54243 16.1598 9.80148L11.4004 15.1393C11.2894 15.2638 11.1455 15.3285 11.0002 15.3337Z"
        />
    </StarryUIIcon>
);
